/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RegisterCampaignRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {RegisterCampaignResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const registerCampaign = (request:RegisterCampaignRequest, options?: CashRequestOptions) => post<RegisterCampaignRequest, RegisterCampaignResponse>("/2.0/cash/register-campaign", request, {...options, rejectOnError: true })